<template>
	<CommonHeader class="main_head_block">
		<template v-slot:header>
			<span class="module_heading">Product Alerts</span>
			<i class="fas fa-download icon_two" @click = "exportExcel()"></i>

			<div class="sellerSelector" style="width: 6%; display: flex; align-items: flex-start;">
				<div class="sellerLabel" style="width: auto; padding-right: 10px;">
					SC
				</div>
				<toggle-button
				v-model="isSeller"
				:value="isSeller"
				style="padding-bottom: 5px; margin-left: 0; margin-top: -0.2px;"
				class="form-check-input"
				@input="sellerValueChange($event)"
				@change="onToggleHandler($event)"
			  />
			</div>

			<div v-if="isSeller" class="sel_fil_wrap one">
				<multiselect
					v-model="selectedAccount"
					:options="sellersList"
					:show-no-results="true"
					:searchable="true"
					ref="multiselect"
					label="brand_name"
					track-by="brand_name"
					open-direction="bottom"
					:taggable="false"
					class="form-control multi-dropdown select_filter"
					selectLabel = ""
					selectedLabel = ""
					@select = "selectAccount($event)"
					@remove = "removeAccount($event)"
					/>
			</div>

			<div v-else class="sel_fil_wrap one">
				<multiselect
					v-model="selectedAccount"
					:options="vendorsList"
					:show-no-results="true"
					:searchable="true"
					ref="multiselect"
					label="brand_name"
					track-by="brand_name"
					open-direction="bottom"
					:taggable="false"
					class="form-control multi-dropdown select_filter"
					selectLabel = ""
					selectedLabel = ""
					@select = "selectAccount($event)"
					@remove = "removeAccount($event)"
					/>
			</div>

			<div class="col-md-4 fil_btn">
				<button
					class="btn btn-primary"
					style="font-size: 12px"
					@click="filterByAccount(true)">Filter</button>
			</div>
			

			<div class="adv_fil_wrap">
				<issueAdvanceFilter @getFilterProducts = "getFilterProducts" ref = "issueAdvanceFilter"/>
			</div>
			<div class="head_search">
				<object data='assets/img/search.svg' style="height:18px;width:18px;margin-left:5px;"></object>
			</div>
			<div class="head_search_inp">
				 <input type="search" id="search" class="search" v-model="searchFilterString"  placeholder="Title/Asin/Vendor/Brand" @keyup.enter="getFilterProducts()" style = "border: none;outline:none;padding: 7px 0px 5px 10px;" autocomplete = "off"/>
			</div>
			<ExportFilePopUp @closePopUpExport = "closePopUpExport" :isTimeOut = "isTimeOut" :errorMessage = "errorMessage"/>
		</template>
	</CommonHeader>
</template>

<script>
import Multiselect from "vue-multiselect";
import issueAdvanceFilter from "@/components/product-alerts/IssueAdvanceFilter.vue";
import  ImportTags from "@/components/product/ImportTags.vue";
import  ExportFilePopUp from "@/components/product/ExportFilePopUp.vue";
import CommonHeader from "@/components/CommonHeader.vue"

export default {
  name: "IssueListFilter",
  components:{
	  Multiselect,
	  issueAdvanceFilter,
	  ImportTags,
	  ExportFilePopUp,
	  CommonHeader
  },
  data() {
    return {
		// isSeller:this.$store.state.isSeller || false,
		selectedVendor:[],
		allGroupingTitle:'All',
		selectedBrandProfle:[],
		isTimeOut: false,
		accountsList: [],
		vendorsList: [],
		sellersList: [],
		selectedAccount: undefined,
    };
  },
  mounted(){
	const vm = this
	// this.$store.dispatch('productAlerts/listAccounts').then(res => {
	// 	vm.accountsList = res
	// })
	this.$store.dispatch('productAlerts/listVendors').then(res => {
		vm.vendorsList = res
	})
	this.$store.dispatch('productAlerts/listSellers').then(res => {
		vm.sellersList = res
	})
  },
  methods: {
	closePopUpExport(){
		this.isTimeOut = false
		this.downloadLink = ''
		this.errorMessage = ''
	},
    
    getFilterProducts(data) {
		this.$store.state.currentPageNumber = 1

		const q = this.searchFilterString
		const isSeller = this.isSeller
		this.$store.state.productAlerts.issueFilters.q = q
		let partneruuid, marketplaceId
		if (this.selectedAccount) {
			this.$store.state.productAlerts.selectedAccount = this.selectedAccount
			partneruuid = this.selectedAccount.partneruuid
			marketplaceId = this.selectedAccount.marketplace_id
		}
		const vm = this
		this.$store.dispatch("productAlerts/list", {...data, partneruuid, marketplaceId, q, isSeller}).then(res => {
			vm.$store.state.productAlerts.issuesList = res
		})
    },
   selectAccount(){
   },
   removeAccount(){
   },
   filterByAccount(){
		console.log(this.selectedAccount)

		const isSeller = this.isSeller
		let partneruuid, marketplaceId
		if (this.selectedAccount) {
			this.$store.state.productAlerts.selectedAccount = this.selectedAccount
			partneruuid = this.selectedAccount.partneruuid
			marketplaceId = this.selectedAccount.marketplace_id
		}
		const vm = this
		this.$store.dispatch("productAlerts/list", {partneruuid, marketplaceId, isSeller}).then(res => {
			vm.$store.state.productAlerts.issuesList = res
		})
   },
   	exportExcel(data){
		console.log('EXPORT_EXCEL')
		
		this.$store.state.currentPageNumber = 1

		const q = this.searchFilterString
		let partneruuid, marketplaceId
		if (this.selectedAccount) {
			this.$store.state.productAlerts.selectedAccount = this.selectedAccount
			partneruuid = this.selectedAccount.partneruuid
			marketplaceId = this.selectedAccount.marketplace_id
		}
		const vm = this

		// console.log(...this.$store.state.productAlerts.issueFilters)

		this.$store.dispatch("productAlerts/export", {...data, ...this.$store.state.productAlerts.issueFilters, partneruuid, marketplaceId, q, isSeller: this.$store.state.isSeller}).then((response) => {
			
			if(response && response.status == 200){
				vm.isTimeOut = false
				vm.downloadLink = response.data.Location
				vm.errorMessage= response.data.noClientError ? response.data.errorMessage : null
				window.$("#exportFilePopUp").modal({
					show: true
				});
			}
			else{
				vm.isTimeOut = true
				vm.errorMessage = 'Export in progress.. you will receive the .csv file via email shortly.'
				window.$("#exportFilePopUp").modal({
					show: true
				});
			}

		});

	},
  },
  computed: {
	isSeller:{
		set(val){
			this.$store.state.isSeller = val
		},
		get(){
			return this.$store.state.isSeller
		}
	},
    searchFilterString: {
      set(val) {
		if(!val){
			this.$store.state.searchFilterString = val
			this.getFilterProducts();
		}
		else{
			this.$store.state.searchFilterString = val

		}
		this.$store.commit("resetTableFooterFilter");
      },
      get() {
          return this.$store.state.searchFilterString;
      }
    }
  }
};
</script>

<style lang="scss">
.sellerLabel {
	font-weight: bold;
	margin-left: 5px;
	text-align: left;
}
.sellerSelector{
	margin-top: 26px;
	width: 65px;
}
.fil_btn{
	margin-top: 15px;
	margin-left: 15px;
}
.main_head_block{
.head_block{
	margin: 0px;
	padding: 0px; 
	height: 74px
}
.data_notice {
	font-size: larger;
}
.module_heading{
	padding-top:25px;
	height: 29px;
	min-width: 94px;
	color: #000000;
	font-family: Poppins;
	font-size: 21px;
	font-weight: 500;
	letter-spacing: -0.02px;
	line-height: 31px;
}
.add_icon_container{
	height: 43px;
	width: 43px;
	margin-top: 19px;
	margin-bottom: 16px;
	margin-left: 15px;
	padding-left: 2px;
	background-color: #FAFAFA ;
	border-radius: 50%;
	cursor: pointer;
	.icon_add{
		cursor:pointer;
		color: black;
		height: 17px;
		width: 17px;
		opacity: 0.81;
		margin: 13px;
	}
}

.icon_one{
	cursor:pointer;
	color: black;
    height: 18px;
    width: 18px;
    opacity: 0.81;
    margin-top: 32px;
    margin-left: 18px;
}
.icon_two{
	color: black;
    height: 18px;
    width: 18px;
    opacity: 0.81;
    margin-top: 32px;
    margin-left: 6px;
	cursor: pointer;
}
.sel_fil_wrap{
	margin-top:15px;
}
.sel_fil_wrap.one{
	margin-left: 18px;
}
.sel_fil_wrap.two{
	margin-left: 9px;
}
.sel_fil_wrap.three{
	margin-left: 9px;
}
.sel_fil_wrap.four{
	margin-left: 9px;
}
.check_fil_wrap{
	margin-left: 2px;
	margin-top: 34px;
}
.adv_fil_wrap{
	position: absolute;
    right: 21px;
    padding-top: 24px;
}
.head_search{
	height: 43px;
    width: 43px;
    border-radius: 50%;
    background-color: #ffbf3f;
    position: absolute;
    right: 38px;
    top: 15px;
	padding-left: 9px;
    padding-top: 12px;
	.icon{
		padding: 12px 25px 12px 17px;
		height: 18px;
		width: 18px;
		text-align: center;
	}
	.text{
		color: #333;
		font-family: "Nunito Sans";
		font-size: 14px;
		font-weight: 600;
		letter-spacing: -0.03px;
		float: right;
    	margin-right: 10px;	
	}
}
.head_search_inp{
	right: 90px;
    top: 15px;
	position:absolute;
	box-sizing: border-box;
	height: 43px;
	// width: 220px;
	border: 1px solid #979797;
	border-radius: 6px;
	background-color: #FFFFFF;
	margin-left: 10px;
	padding-left:4px;
	padding-right:4px;
	}
}
</style>
